<div class="text-center flex-grow font-bold">
  @if (dialogConfig?.data?.question && dialogConfig?.data?.name) {
    <div>{{ dialogConfig?.data?.name }}</div>
    <div class="font-bold text-lg">{{ dialogConfig?.data?.question }}:</div>
  } @else {
    @if (dialogConfig?.data?.question) {
      <span>{{ dialogConfig?.data?.question }}:</span>
      <br />
    }
    @if (dialogConfig?.data?.name) {
      <h4 class="text-center">{{ dialogConfig?.data?.name }}</h4>
    }
  }
  @if (dialogConfig?.data?.explanation) {
    <div>{{ dialogConfig?.data?.explanation }}</div>
  }
</div>

<footer
  class="w-auto flex flex-shrink-0 py-4"
  [class.justify-between]="dialogConfig?.data?.cancel !== null"
  [class.justify-center]="dialogConfig?.data?.cancel === null"
>
  @if (dialogConfig?.data?.cancel !== null) {
    <p-button severity="danger" (click)="close($event)" variant="outlined">
      {{ dialogConfig?.data?.cancel ?? 'Cancel' }}
    </p-button>
  }
  <p-button (click)="confirm()">
    {{ dialogConfig?.data?.action ?? 'Confirm' }}
  </p-button>
</footer>
